import { Component } from "react";
import { Subscription } from "rxjs";
import { IOC_TYPES } from "../../context/ioc.types";
import { lazyInject } from "../../context/module";
import { WindowService } from "../../services/window.service";
import { OptionalChildrenProps } from '../../types/react.types';
import { MotiveLocationTypes } from "../../utils/request.utils";
import { RxUtils } from "../../utils/rx-utils";
import { MotiveComponent } from "../ui/motive/motive.component";
import { AdSlots } from '../ui/motive/ad-slots';
import styles from './motive-frame.component.module.scss';

interface MotiveFrameProps extends OptionalChildrenProps {
    hideSidePanes?: boolean;

}

interface MotiveFrameState {
    top: number;
    leftAdEnabled: boolean;
    rightAdEnabled: boolean;
    mediumScreen: boolean;
}

export default class MotiveFrame extends Component<MotiveFrameProps, MotiveFrameState> {
    @lazyInject(WindowService) private windowService: WindowService;
    private scrollSub: Subscription;

    readonly state: Readonly<MotiveFrameState> = {
        top: 0,
        leftAdEnabled: true,
        rightAdEnabled: true,
        mediumScreen: false,
    };
    constructor(props: MotiveFrameProps) {
        super(props);

    }

    componentDidMount() {
        // Rails are now CSS position:sticky (see the .railSticky rule) -- no scroll listener needed.
        // The old onScroll handler re-set `top` on every scroll (the source of the CLS-on-scroll note)
        // and drove a JS reposition that never fired on this body-scrolled layout.
        this.windowService.onResize.subscribe({
            next: () => {
                this.updateShouldHideSidePanels();
            }
        })
        this.updateShouldHideSidePanels();
        // window.addEventListener('scroll', this.handleScroll);

    }

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.handleScroll);
        RxUtils.safeCloseSubscriber(this.scrollSub);
    }

    updateShouldHideSidePanels() {
        // BrowserUtils.runIfWindowExists(() => {
        //     this.setState({
        //         rightAdEnabled: window.innerWidth > 768 + 160,
        //         leftAdEnabled: window.innerWidth > 768 + 160 + 160,
        //         mediumScreen: window.innerWidth < 978 + 160 + 160
        //     })
        // })
    }

    render() {

        var cssClass = `${this.state.mediumScreen ? styles['md-screen'] : ''}`;
        if (this.props.hideSidePanes || (!this.state.leftAdEnabled && !this.state.rightAdEnabled)) {
            cssClass = `${styles['hide-side-panels']} ${cssClass}`;
        } else if (!this.state.leftAdEnabled && this.state.rightAdEnabled) {
            cssClass = `${styles['right-ad-only']} ${cssClass}`;
        }


        return <div className={`${styles['motive-frame']} ${cssClass}`}>
            {
                (!this.props.hideSidePanes && this.state.leftAdEnabled) && <div className={`${styles['side-pane']} ${styles['left-pane']}`}>
                    <div className={styles.railSticky}>
                        <MotiveComponent
                            data={AdSlots.desktopRail} containerWidth="100%" containerHeight="600px"
                            location={MotiveLocationTypes.convertPageLeft}
                            adWidth="100%"
                            adHeight="600px" showAds={true} className='height_major'
                        >
                        </MotiveComponent>
                    </div>
                </div>
            }
            <div className={styles['content']}>
                {
                    this.props.children
                }
            </div>
            {
                (!this.props.hideSidePanes && this.state.rightAdEnabled) && <div className={`${styles['side-pane']} ${styles['right-pane']}`}>
                    <div className={styles.railSticky}>
                        <MotiveComponent
                            data={AdSlots.desktopRail} containerWidth="100%" containerHeight="600px"
                            location={MotiveLocationTypes.convertPageRight} adWidth="100%" adHeight="600px" showAds={true} className='height_major'
                        >
                        </MotiveComponent>
                    </div>
                </div>
            }
        </div >;
    }
}